import { defineComponent, onMounted, onUnmounted } from 'vue';
import { MultiSelect } from '@studyportals/multiselect';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import PartnershipTypeCode from '@/presentation/components/campaign-settings/partnership-type/partnership-type.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		MultiSelect
	},
	setup: () => {
		const code = new PartnershipTypeCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			partnershipTypeDropdown: code.partnershipTypeDropdown,
			options: code.options,
			isLoading: code.isLoading,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			isFieldClashingWithCampaignLiftExcluded: code.isFieldClashingWithCampaignLiftExcluded,
			nameOfSelectedPartnershipType: code.nameOfSelectedPartnershipType,
			isCampaignCreation: code.isCampaignCreation,
			validationMessage: code.validationMessage,
			setPartnershipType: code.setPartnershipType.bind(code)
		};
	}
});
